import { UserManager, WebStorageStateStore } from "oidc-client-ts";

import { isLoginEnabled } from "@/api/authSession";
import config from "@/constants/config";

let userManager: UserManager | null = null;
let userManagerLanguage: string | null = null;

const getClientId = (): string => {
  if (config.ssoConfig.clientId) {
    return config.ssoConfig.clientId;
  }

  if (isLoginEnabled()) {
    throw new Error("Login is enabled, but ssoConfig.clientId is missing.");
  }

  // Auth is disabled for this tenant, but AuthProvider is still mounted.
  // Return a placeholder client id so the OIDC manager can be constructed
  // without enabling any real sign-in flow.
  return "__login_disabled__";
};

export const getUserManager = (language: string): UserManager => {
  if (userManager && userManagerLanguage === language) {
    return userManager;
  }

  userManagerLanguage = language;
  userManager = new UserManager({
    authority: config.ssoConfig.authorityUrl,
    client_id: getClientId(),
    redirect_uri: globalThis.origin,
    silent_redirect_uri: `${globalThis.origin}/silent-renew.html`,
    response_type: "code",
    scope: "openid profile offline_access",
    automaticSilentRenew: isLoginEnabled(),
    // The OP check-session iframe has proven unreliable in production for this
    // deployment and can emit false signed-out events immediately after login.
    // We rely on token expiry / renew failures instead of remote session polling.
    monitorSession: false,
    redirectMethod: "replace",
    acr_values: `culture:${language}`,
    userStore: new WebStorageStateStore({
      store: globalThis.localStorage,
    }),
  });

  return userManager;
};
